/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../shared/qrequest";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Alert from "./Alert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";

class Logout extends BaseCom {

    componentDidMount() {
        qreq.post('/api/auth/logout', {}, j => {
            let follow = this.qs('follow');
            if (follow) {
                follow = follow.replace(/\/\//g, '').replace(/:/g, '');
                window.location.assign(follow);
            }
            else
                window.location.assign('/');
        }, () => window.location.assign('/'));
    }

    render() {
        return <Alert message="Please wait..." />;
    }
}

export default withParamsAndNavigate(Logout);